import {useMarkAssistantConversationAsViewedMutation} from "../../../types/generated";

export type MarkConversationAsViewedProps = {
    conversationId: string;
    universityId: string;
    token?: string;
};

export const useMarkConversationAsViewed = () => {
    const [sendAssistantMessage] = useMarkAssistantConversationAsViewedMutation();

    function markConversationAsViewed({
        conversationId,
        universityId,
        token,
    }: MarkConversationAsViewedProps) {
        const localStorageKey = `ASSISTANT_${universityId}_${conversationId}`;
        const localStorageValue = localStorage.getItem(localStorageKey);

        if (localStorageValue) {
            return;
        }
        sendAssistantMessage({
            variables: {
                conversationId,
                universityId,
                token,
            },
        });
        localStorage.setItem(localStorageKey, "true");
    }

    return {markConversationAsViewed};
};
